import { useAdminMode } from "@/contexts/admin-mode-provider";
import {
  type TeamLLMModelGroupDTO,
  useTeams,
} from "@/contexts/teams-provider";
import { useMemo } from "react";

/**
 * Returns the team's LLM groups filtered to what the current user can see.
 * Admin-only models are hidden unless the user is an admin with admin mode
 * enabled. Empty groups are dropped.
 */
export function useVisibleLLMGroups(): TeamLLMModelGroupDTO[] {
  const { teamLLMListGrouped, isAdmin } = useTeams();
  const { isAdminMode } = useAdminMode();
  const canUseAdminOnlyModels = isAdmin && isAdminMode;

  return useMemo(
    () =>
      teamLLMListGrouped
        .map((group) => ({
          ...group,
          models: group.models.filter(
            (model) => !model.adminOnly || canUseAdminOnlyModels
          ),
        }))
        .filter((group) => group.models.length > 0),
    [teamLLMListGrouped, canUseAdminOnlyModels]
  );
}
